export default __webpack_public_path__ + "static/media/lights_out_game.7e16f783.png";